import createClient from 'openapi-fetch'
import { authMiddleware } from './auth-middleware'
import { dedupeGetMiddleware } from './dedupe-get-middleware'
import { nonJsonResponseMiddleware } from './non-json-response-middleware'
// Generated from openapi/openapi.yaml via `npm run generate:client` (auto-runs
// on `npm install` via the postinstall script). NOT committed — see
// docs/api-client-sync.md. If this import fails to resolve, run
// `npm run generate:client`.
import type { paths } from './schema.gen'

// Falls back to '/api' so the client works with no .env.local present (see
// .env.example) — matches the BFF-proxied path used in localdev/CI.
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api'

/**
 * Typed API client, generated from the Commerce Core OpenAPI contract
 * (ADR-0008 — the contract, not a shared package, is the cross-repo seam).
 * Usage: `const { data, error } = await apiClient.GET('/health')`.
 *
 * This is the ONLY client apps/web makes API calls through (F0.2 — no
 * hand-rolled fetch, no second client). `credentials: 'same-origin'` (the
 * fetch default) is enough: the BFF-proxied `/api` path is always
 * same-origin, so the browser attaches the httpOnly session cookie
 * automatically — this code never reads or sets that cookie itself, and
 * never attaches an `Authorization` header (there is no bearer token to
 * attach; the SPA holds none, see apps/web/src/lib/auth/session-store.ts).
 * `authMiddleware` layers the CSRF header + 401-session-expiry detection
 * every call gets for free by going through this client. `nonJsonResponseMiddleware`
 * runs first (registered last — openapi-fetch runs response middleware in
 * reverse-registration order) so it can sanitize a non-JSON body (e.g. an
 * nginx 502/504 HTML error page) into `application/problem+json` — and
 * preserve the real HTTP status doing it — before anything downstream,
 * including `authMiddleware`'s own 401 check, ever sees the response.
 *
 * `dedupeGetMiddleware` is registered FIRST (before both of the above) so
 * that, by the same reverse-registration-order rule, its `onResponse` runs
 * LAST — after the response has already been through `authMiddleware`'s
 * 401 check and `nonJsonResponseMiddleware`'s sanitization. That is the
 * fully-processed response it shares with any concurrent, byte-identical GET
 * (UID-589 task 2) — see the doc comment on `dedupeGetMiddleware` for why a
 * follower request never re-runs the other two middlewares itself.
 */
export const apiClient = createClient<paths>({ baseUrl: API_BASE_URL })
apiClient.use(dedupeGetMiddleware)
apiClient.use(authMiddleware)
apiClient.use(nonJsonResponseMiddleware)
